/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_CreateMyAbsenceReportBody = {
    /**
     * Report type: SICK, ACCIDENT or CHILD_SICK
     */
    absence_type: employee_selfservice_CreateMyAbsenceReportBody.absence_type;
    /**
     * ACCIDENT only, required: day of the accident (YYYY-MM-DD), on or before from_date
     */
    accident_date?: string;
    /**
     * The employee went home at this time on the first day (HH:MM); shifts on that day are kept
     */
    first_day_from_time?: string;
    /**
     * First day of the absence (YYYY-MM-DD); at most 7 days before today
     */
    from_date: string;
    /**
     * Optional note for the office
     */
    notes?: string;
    /**
     * Last day of the absence (YYYY-MM-DD)
     */
    to_date: string;
    /**
     * ACCIDENT only, required: the accident happened at work or on the way to work
     */
    work_related?: boolean;
};
export namespace employee_selfservice_CreateMyAbsenceReportBody {
    /**
     * Report type: SICK, ACCIDENT or CHILD_SICK
     */
    export enum absence_type {
        SICK = 'SICK',
        ACCIDENT = 'ACCIDENT',
        CHILD_SICK = 'CHILD_SICK',
    }
}

